import * as c from '../../constants/notification';
import {
  FM_SAVE_REVISION_SUCCESS,
  FM_SAVE_REVISION_FAILURE,
  FM_OPEN_REVISION_SUCCESS,
  FM_OPEN_REVISION_FAILURE,
  FM_NEW_CONCEPT_SUCCESS,
  FM_NEW_CONCEPT_FAILURE,
} from '../../constants/filemanager';
import {
  JOURNAL_SAVE_SUCCESS,
  JOURNAL_SAVE_FAILURE,
} from '../../constants/journal';
import { GAME_LEVEL_UP_SUCCESS } from '../../constants/game';

let nextId = 1;

export const defaultState = [];

export const defaultToast = {
  type: c.NOTIFICATION_TYPE_TOAST,
  message: '',
  category: 'info',
  sticky: false,
  timeout: 3000,
  inverted: false,
};

const createToast = (message, category, sticky, timeout, inverted) => ({
  type: c.NOTIFICATION_TYPE_TOAST,
  message,
  category,
  sticky: sticky || defaultToast.sticky,
  timeout: timeout || defaultToast.timeout,
  inverted: inverted || defaultToast.inverted,
  id: nextId++,
});

const createModal = (
  title,
  body,
  backdrop,
  bsSize,
  closeButton,
  buttons = [],
  logoutOnClose
) => ({
  id: nextId++,
  type: c.NOTIFICATION_TYPE_MODAL,
  title,
  body,
  backdrop: backdrop || false,
  bsSize: bsSize || null,
  closeButton,
  buttons,
  logoutOnClose,
});

const notifications = (state = defaultState, action) => {
  switch (action.type) {
    case c.NOTIFICATION_APPEND_MODAL:
      return [
        ...state,
        createModal(
          action.title,
          action.body,
          action.backdrop,
          action.bsSize,
          action.closeButton,
          action.buttons,
          action.logoutOnClose
        ),
      ];
    case c.NOTIFICATION_APPEND_TOAST:
      return [
        ...state,
        createToast(
          action.message,
          action.category,
          action.sticky,
          action.timeout,
          action.inverted
        ),
      ];
    case c.NOTIFICATION_DISMISS:
      const pos = state.findIndex((item) => item.id === action.id);
      if (pos < 0) {
        return state;
      }
      return [...state.slice(0, pos), ...state.slice(pos + 1)];
    // notifications for file manager results
    case FM_SAVE_REVISION_SUCCESS:
      if (action.autoSave) {
        return state; // no notification needed for autosave
      }
      return [...state, createToast(`Saved ${action.name}`, 'success')];
    case FM_SAVE_REVISION_FAILURE:
      return [
        ...state,
        createToast(`Error saving ${action.name}`, 'error', true),
      ];
    case FM_OPEN_REVISION_SUCCESS:
      return [...state, createToast(`Opened ${action.name}`, 'success')];
    case FM_OPEN_REVISION_FAILURE:
      return [
        ...state,
        createModal(
          `Error opening ${action.name}`,
          action.error ? action.error.message : '',
          true
        ),
      ];
    case FM_NEW_CONCEPT_SUCCESS:
      return [...state, createToast('Started a new design concept', 'success')];
    case FM_NEW_CONCEPT_FAILURE:
      return [
        ...state,
        createToast('Error starting a new design concept', 'error', true),
      ];
    case JOURNAL_SAVE_SUCCESS:
      return [
        ...state,
        createToast('Saved changes to your journal', 'success'),
      ];
    case JOURNAL_SAVE_FAILURE:
      return [
        ...state,
        createToast('Error saving your journal', 'error', true),
      ];
    case GAME_LEVEL_UP_SUCCESS:
      if (action.result.success) {
        const level = action.result.activity.game.level.level;
        return [
          ...state,
          createToast(`You moved up to Level ${level}`, 'success'),
        ];
      } else {
        return [
          ...state,
          createModal('Error leveling up', action.result.message, true),
        ];
      }
    default:
      return state;
  }
};

export default notifications;
